import { is, ro } from "date-fns/locale";
import uiUtilInstance from "../utilities/uiUtil";
import { BillStatus, FoodType, InternalBillType, OfferType, PayMedium, Spicy } from "./constant";

export const INITIAL_BILL_PAYMENT_DETAILS_STATE = {
  onlinePayThrough: "",
  onlinePayMedium: "",
  onlinePay: 0.0,
  isOnlinePayEnabled: false,
  cashPayThrough: "",
  isCashPayEnabled: false,
  cashPay: 0.0,
  cashTender: 0.0,
  cashReturn: 0.0,
  delvName: "",
  payMedium: PayMedium.NOPAY,
  deliveryCharge: 0.0,
  sgst: 0.0,
  cgst: 0.0,
  totalPrice: 0.0,
  finalPrice: 0.0,
  sgstAmt: 0.0,
  cgstAmt: 0.0,
  roundOff: 0.0,
  offerType: OfferType.No_Offer,
  offerValue: 0.0,
  isGstAllowed: false,
  coupon: "",
};
export const INITIAL_BILL_HOTEL_DETAILS_STATE = {
  hotelBillId: "",
  hotelBillNo: "",
  roomNo: "",
  saved: false,
  booked: false,
};

export const INITIAL_BILL_DETAILS_STATE = {
  billNo: "",
  delItems: [],
  billStatus: BillStatus.NO_ENTRY,
  pointRedeem: 0,
  token: 0,
  roundOff: 0.0,
  homeDelvName: "",

  // kot: 0,

  homeDelvId: "", // will need local state
  homeDelvOtp: "",
  generateOtp: "", //
  onlineBillOtherName: "",
  settleDown: false,
  payLaterSignal: false,
  createdAt: "",
  tripUpdateReq: false,
  tripStatus: "",
  pTripStatus: "",
  assignedBy: "",
  assignedByName: "",
  transactionId: "", // online transaction id
  payAtCounterOpt: false,
  subTotal: 0.0,
  cgst: 0.0,
  cgstAmt: 0.0,
  sgstAmt: 0.0,
  sgst: 0.0,
  isGstAllowed: true,
  roundOff: 0.0,
  cashTender: 0.0,
  cashReturn: 0.0,
  isPointAdded: false,
  total: 0.0,
  currDues: 0.0,
  pendingAmt: 0.0,
  lpatialAmt: [],
  offerDenom: OfferType.No_Offer,
  offerAmt: 0.0,
  billType: InternalBillType.TakeAway,
  lapsedTime: 0, // table active time?

  token: -1,
  kotCopies: 1,
  kotNo: 0,
  billedFrom: -1,
  tableId: -1,
  tableNo: -1,
  tableName: "",
  isPaid: false,
};
export const INITIAL_BILL_PARTIAL_PAY_STATE = {
  id: "",
  partialAmt: 0.0,
  onlineBillPaidThrough: "",
  onlinePay: 0.0,
  cashBillPaidThrough: "",
  cashPay: 0.0,
  paidAcceptBy: "",
  paidOn: "",
  cashTendered: 0.0,
  cashReturn: 0.0,
  partiallyPaid: false,
  lpatialAmt: [],
  duesAmt: 0.0,
};
export const INITIAL_BILL_CUSTOMER_DETAILS = {
  custId: "",
  custMob: "",
  custName: "",
  custEmail: "",
  address: "",
  custGstDetails: "",
  custCompanyName: "",
  royalityPoint: 0.0,
  loyalityAllowed: false,
};

export const INITIAL_RIDER_DETAILS_STATE = {
  riderId: "",
  riderName: "",
  mobile: "",
};

export const INITIAL_BILL_ITEM_STATE = {
  prdId: "",
  name: "",
  sgst: 0,
  cgst: 0,
  price: 0.0,
  foodQuantityName: "",
  priceIndex: 0,
  finalprice: 0.0,
  note: "",
  savedQuantity: 1,
  quantity: 1,
  offerDenom: OfferType.No_Offer,
  offerAmt: 0.0,
  print: false,
  combo: false,
};
export const INITIAL_PRODUCT_DETAILS_STATE = {
  id: "",
  catgId: "",
  catgName: "",
  name: "",
  productImage: [],
  ingredients: "",
  spicy: Spicy.LESS_SPICY,
  foodType: FoodType.VEG,
  sgst: 0.0,
  cgst: 0.0,
  outOfStock: false,
  offertype: OfferType.No_Offer,
  offerAmt: 0.0,
  price: [],
  liveStockCount: "",
  unitCount: 0.0,
  smallUnitCount: 0.0,
  unitRestrictions: 0.0,
};
export const INITIAL_BILL_DETAILS = {
  subTotal: 0.0,
  cgst: 0.0,
  cgstAmt: 0.0,
  sgstAmt: 0.0,
  sgst: 0.0,
  isGstAllowed: true,
  roundOff: 0.0,
  cashTender: 0.0,
  cashReturn: 0.0,
  pointRedeem: 0.0,
  isPointAdded: false,
  total: 0.0,
  currDues: 0.0,
  pendingAmt: 0.0,
  offerDenom: OfferType.No_Offer,
  offerAmt: 0.0,
  billingType: InternalBillType.TakeAway,
  lapsedTime: 0,
  lpatialAmt: [],
  token: -1,
};

